import { put } from 'redux-saga/effects';
import * as actions from '../actions';

export function* stageSaga(action) {
    try 
    {
        yield put(actions.stageSuccess(action.stage));
        window.scrollTo(0, 0)
    }
    catch(e) {
        console.log(e);
    }
}

export function* updateSourceSaga(action) {
    try 
    {
        yield put(actions.updateSourceSuccess(action.flag));
    }
    catch(e) {
        console.log(e);
    }
}
